import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import featureFlags from '@masfront/common-feature-flags'

import { setFeatureFlagsAction } from '../store/featureFlags.reducer'

export default function useFeatureFlagsSync() {
  const dispatch = useDispatch()
  const flags = featureFlags.getFlags()

  const setFlags = () => {
    dispatch(setFeatureFlagsAction(flags))
  }

  useEffect(() => {
    if (flags) {
      setFlags()
    }

    featureFlags.subscribe(setFlags)

    return () => {
      featureFlags.unsubscribe(setFlags)
    }
  }, [])
}
